import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import DatePicker from "react-datepicker"
import { Button } from "react-bootstrap"
import styled from "styled-components"

import { TextInput } from "quorumdesign"

import { columnSearchDateRangeConnection } from "sheets/column-search-selectors"
import { dateToDayMonthYear } from "imports/desktopHelperFunctions"

// eslint-disable-next-line react/prop-types
const CustomInput = React.forwardRef(({ value, onFocus }, ref) => (
    <TextInput
        dataCy="daterangepicker-input"
        ref={ref}
        leftIconFamily="far"
        onFocus={onFocus}
        placeholder="Start Date - End Date"
        value={value}
        inputStyle={{
            fontSize: "13px",
        }}
        isCentered
    />
))

const DateRangeWrapper = styled.div`
    & .react-datepicker-popper {
        width: calc(1rem * 32);
    }
`

/**
 * Wrapper component to render a Date Range Picker in a column of a sheet or resource table
 */
export class ColumnSearchDateRangePicker extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            startDate: props.startDate,
            endDate: props.endDate,
        }
    }

    onDatesChange = ([startDate, endDate]) => {
        this.setState((state) => ({ ...state, startDate, endDate }))
    }

    // on submit, extract out the day/month/year to be sent to the store
    onSubmit = () => {
        this.props.search({
            startDate: dateToDayMonthYear(this.state.startDate),
            endDate: dateToDayMonthYear(this.state.endDate),
        })

        this.props.unfocusColumn()
    }

    render() {
        const { startDate, endDate } = this.state
        return (
            <DateRangeWrapper className="quorum-date-range-picker">
                <Button block variant="primary" bsSize="sm" className="date-picker-button" onClick={this.onSubmit}>
                    Apply
                </Button>
                <DatePicker
                    customInput={<CustomInput />}
                    onChange={this.onDatesChange}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    monthsShown={2}
                />
            </DateRangeWrapper>
        )
    }
}

ColumnSearchDateRangePicker.propTypes = {
    autoFocus: PropTypes.bool,
    autoFocusEndDate: PropTypes.bool,
    columnData: PropTypes.object,
    hideKeyboardShortcutsPanel: PropTypes.bool,
    // wrapper function for filter action creator
    search: PropTypes.func.isRequired,
    // should the component find the startDate / endDate boundaries from the column data
    shouldUseColumnDataForInitialValues: PropTypes.bool,
    value: PropTypes.shape({
        startDate: PropTypes.object,
        endDate: PropTypes.object,
    }),
}

ColumnSearchDateRangePicker.defaultProps = {
    autoFocus: false,
    autoFocusEndDate: true,
    columnData: undefined,
    hideKeyboardShortcutsPanel: true, // we don't like the panel
    shouldUseColumnDataForInitialValues: false,
    value: {
        startDate: null,
        endDate: null,
    },
}

export default connect((state, props) => columnSearchDateRangeConnection(state, props), {})(ColumnSearchDateRangePicker)
